import createConverter from './lib/create_converter';
import CommunicationQueue from 'models/communication_queue';

export default createConverter(CommunicationQueue);



// WEBPACK FOOTER //
// ./src/scripts/application/dto_converters/communication_queue_converter.js